var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flowlu-widget" }, [
    _c("div", { staticClass: "flowlu-widget-operations" }, [
      _c(
        "div",
        { staticClass: "flowlu-widget-operations_buttons" },
        [
          _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.transferToFlowlu } },
            [_vm._v(" " + _vm._s(_vm.$t("message.flowluTransfer")) + " ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }